import { useLocation } from 'react-router-dom'

import { getAuthFromSearch } from '@/lib/auth'

export function useAuth() {
  const location = useLocation()
  return getAuthFromSearch(location.search)
}
